import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ThemedShopPage() {
  const { userId } = useParams();
  const [html, setHtml] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/shop-customization/${userId}/themed`);
        setHtml(data.html || null);
      } catch (e) { setHtml(null); } finally { setLoading(false); }
    })();
  }, [userId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="themed-shop-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#D97736]" />
      </div>
    );
  }

  if (!html) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAFA] gap-3" data-testid="themed-shop-empty">
        <p className="text-[#5C5C5C]">Šim veikalam nav pielāgotas tēmas.</p>
        <Link to={`/shop/${userId}`} className="text-[#D97736] underline">Atvērt standarta veikalu</Link>
      </div>
    );
  }

  return (
    <iframe
      title="themed-shop"
      sandbox="allow-same-origin"
      srcDoc={html}
      className="w-full min-h-screen border-0"
      style={{ height: '100vh' }}
      data-testid="themed-shop-frame"
    />
  );
}
